import { i18n as printTicket } from "../printTicket";
import { i18n as rescheduleTicket } from "../components/RescheduleTicketView";
import en from "./en";
import es from "./es";

export default {
  en: { ...en, ...printTicket.en, ...rescheduleTicket.en },
  es: { ...es, ...printTicket.es, ...rescheduleTicket.es },
};
